import { getSubscriptionSearchParamsString } from '@proton/payments/core/subscription/search-params';

/*
This class is added to any upsell/upgrade components that can direct users to account app or trigger LumoPlusUpsellModal for mobile app
*/
export const LUMO_UPGRADE_TRIGGER_CLASS = 'lumo-upgrade-trigger';

const lumoSearchParams = getSubscriptionSearchParamsString({ totalLumo: 1 });
export const LUMO_PLUS_UPGRADE_PATH = `/dashboard?${lumoSearchParams}`;
export const LUMO_SIGNUP_PATH = '/signup';
export const LUMO_BUSINESS_PATH = '/business/lumo';
export const LUMO_TO_WORKSPACE_PATH = '/business/plans';

// File upload limits
// Unified limit for all ingestion paths (device upload, project KB upload, Drive browser
// add-to-KB, and linked-folder uploads). All of these paths download + process + index
// the file on the main thread, so the same limit must apply everywhere to avoid freezes.
export const MAX_ASSET_SIZE = 25 * 1024 * 1024; // 25MB

// Maximum number of attachments that can be staged in the composer at once.
// Mirrors the limit used by other assistants (e.g. Claude allows 20).
export const MAX_PROVISIONAL_ATTACHMENTS = 20;

export const LUMO_FULL_APP_TITLE = 'Lumo: Privacy-first AI assistant where chats stay confidential';

export const LUMO_APP_NAME = 'Lumo';
